import { reExportedColors } from '../../index'
import TextButton from '../TextButton'
import { styled } from '@mui/material/styles'

const StyledSelectButton = styled(TextButton)({
  '&&.MuiButton-root': {
    background: reExportedColors.MEDIUM_GREY,
    fontSize: '.8rem',
    height: '29px',
    padding: '3px 8px'
  }
})

const SaveButton = ({ className, onClick, disabled }) => {
  return (
    <StyledSelectButton
      className={className}
      clickHandler={onClick}
      disabled={disabled}
    >
      Select
    </StyledSelectButton>
  )
}

export default SaveButton
